import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-bullet",
  "use": "arrow-bullet-usage",
  "viewBox": "6 4 6 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"6 4 6 10\" id=\"arrow-bullet\">\n    <path fill-rule=\"evenodd\" d=\"M6 4h2l4 5-4 5H6l4-5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol